import { useWorkspace } from './getQueries';

const useWorkspacePermissions = (workspaceId) => {
  const { data: workspace, isLoading } = useWorkspace(workspaceId);

  if (!workspace || isLoading) {
    return {
      canEdit: false,
      canDelete: false,
      canInvite: false,
      canManageMembers: false,
      canViewSettings: false,
      canManageBilling: false,
      isOwner: false,
      isAdmin: false,
      isMember: false,
      isLoading,
    };
  }

  const userRole = workspace.user_role;
  const userPermissions = workspace.user_permissions || [];

  // Role-based checks
  const isOwner = userRole === 'owner';
  const isAdmin = userRole === 'admin';
  const isMember = userRole === 'member';
  const isGuest = userRole === 'guest';

  // Permission-based checks
  const hasAdminPermission = userPermissions.includes('admin');
  const hasEditPermission = userPermissions.includes('edit');

  // Derived permissions
  const canEdit = isOwner || hasAdminPermission || hasEditPermission;
  const canDelete = isOwner;
  const canInvite = isOwner || hasAdminPermission;
  const canManageMembers = isOwner || hasAdminPermission;
  const canViewSettings = isOwner || hasAdminPermission || hasEditPermission;
  const canManageBilling = isOwner || hasAdminPermission;

  return {
    canEdit,
    canDelete,
    canInvite,
    canManageMembers,
    canViewSettings,
    canManageBilling,
    isOwner,
    isAdmin,
    isMember,
    isGuest,
    userRole,
    userPermissions,
    isLoading: false,
  };
};

export default useWorkspacePermissions;
